import { platformAPI } from '../services/platformAPI';

const FALLBACK = {
  settings: {
    currency: 'INR',
    customerCurrencies: ['INR', 'USD', 'EUR', 'GBP'],
    tenderCurrencies: ['INR', 'USD', 'EUR', 'GBP', 'CAD', 'AUD'],
    timezone: 'Asia/Kolkata',
    dateFormat: 'DD/MM/YYYY',
    language: 'en',
    country: 'India',
    financialYearStartMonth: 4,
    passwordMinLength: 6,
    uploadMaxMb: 50,
    auditRetentionDays: 90,
    personnelTypes: [
      { code: 'employee', label: 'Employee' },
      { code: 'consultant', label: 'Consultant' }
    ],
    importLists: {
      customerCategories: ['Central authority', 'State authority', 'Municipal corporation', 'Metro and rail', 'Port authority', 'Private client'],
      serviceCategories: ['Design and planning', 'Construction supervision', 'Assurance', 'Advisory'],
      serviceBilling: ['Lump sum', 'Man-month', 'Percentage of project cost'],
      sectorGroups: ['Transport', 'Structures', 'Urban', 'Water', 'Rail'],
      tenderTypeGroups: ['Open competition', 'Invited', 'Panel', 'Private'],
      sourceGroups: ['Portal', 'Authority site', 'Direct'],
      credentialCategories: ['Certification', 'Registration', 'Insurance', 'Accreditation', 'Other'],
      eligibilityCategories: ['Technical', 'Financial', 'Experience', 'Legal', 'Certification', 'Personnel', 'General'],
      paymentModes: ['NEFT', 'RTGS', 'Demand draft', 'UPI', 'BG', 'Online portal'],
      staffingSources: ['Employee', 'Associate', 'Candidate', 'JV nominee']
    },
    maxUsers: 5,
    maxTenders: 100,
    maxStorageMb: 1000,
    workspace: {
      displayName: 'Dhruv Consultancy',
      legalName: 'Dhruv Consultancy Services Ltd',
      tagline: 'A connected workspace for your business applications.',
      loginLine: 'Welcome to Dhruv Consultancy',
      letterhead: 'Dhruv Consultancy Services Ltd',
      helpText: '',
      primaryColor: '#A63726',
      secondaryColor: '#292724',
      logoUrl: ''
    }
  }
};

/** Active labels from an import list, preserving order. Accepts legacy strings or { value, active }. */
export function activeImportValues(list) {
  return (Array.isArray(list) ? list : [])
    .map((item) => {
      if (item && typeof item === 'object') {
        if (item.active === false || item.isActive === false) return '';
        return String(item.value ?? item.label ?? '').trim();
      }
      return String(item || '').trim();
    })
    .filter(Boolean);
}

/** Stable code for coded dropdowns (payment modes, staffing sources). */
export function importListCode(label) {
  return String(label || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
}

/** Active { value: code, label } rows for coded dropdowns. */
export function activeImportChoices(list) {
  return activeImportValues(list)
    .map((label) => ({ value: importListCode(label), label }))
    .filter((row) => row.value);
}

export function keepCurrent(list, current, fallback) {
  const values = (Array.isArray(list) && list.length ? list : fallback).slice();
  if (current && !values.some((item) => String(item).toLowerCase() === String(current).toLowerCase())) {
    values.unshift(current);
  }
  return values;
}

let cache = null;
let inflight = null;

export function clearOrganisationSettings() {
  cache = null;
  inflight = null;
}

export function loadOrganisationSettings() {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = platformAPI.getOrganisation()
      .then((response) => {
        cache = response.data?.data || FALLBACK;
        return cache;
      })
      .catch(() => FALLBACK)
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

export function currencyChoices(codes, current) {
  const list = Array.isArray(codes) && codes.length ? codes.slice() : FALLBACK.settings.tenderCurrencies.slice();
  if (current && !list.includes(current)) list.unshift(current);
  return list;
}
